import { color as colorObj } from "@/utils/includes";
import { copyObject, mergeObject, substr } from "@/utils/helper";
import { toThousand, toPercent } from "@/utils/filters";
import _ from "lodash";
const substrLength = 40;
/**
 * option的默认值
 * 可通过配置构造函数的config参数重置
 */
const defaultOptions = {
  backgroundColor: "#fff",
  color: [],
  title: {
    show: false,
    textStyle: {
      fontSize: 14
    }
  },
  tooltip: {
    trigger: "axis",
    confine: true,
    color: "#ADB0BA",
    backgroundColor: "#242833",
    opacity: 0.9,
    hightLightColor: "#CD8E46",
    textStyle: {
      color: "#FFFFFF",
      fontSize: 12
    }
  },
  legend: {
    orient: "horizontal",
    bottom: 10,
    itemHeight: 10,
    type: "scroll",
    textStyle: {
      fontSize: 10,
      color: "#5a5a5a"
    }
  },
  barGap: "30%",
  grid: {
    left: 80,
    right: 60,
    top: 60,
    bottom: 80
  },
  xAxis: [
    {
      name: "",
      nameTextStyle: {
        color: "#7F8593"
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "#D1D1D1"
        }
      },
      splitLine: {
        lineStyle: {
          color: "#B3B3CA",
          type: "dashed"
        }
      },
      axisTick: {
        show: false
      },
      splitArea: {
        show: false
      },
      axisLabel: {
        fontSize: 12,
        color: "#2E3341"
      }
    }
  ],
  yAxis: [
    {
      name: "",
      nameTextStyle: {
        color: "#7F8593"
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#B3B3CA",
          type: "dashed"
        }
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "#D1D1D1"
        }
      },
      axisTick: {
        show: false
      },
      splitArea: {
        show: false
      },
      axisLabel: {
        fontSize: 12,
        color: "#2E3341"
      }
    }
  ],
  dataZoom: {
    show: true,
    orient: "horizontal",
    start: undefined,
    end: 100,
    height: 14,
    bottom: 40,
    showDetail: false,
    showDataShadow: false,
    handleSize: "50%",
    handleStyle: {
      color: "#82cbc5"
    },
    textStyle: {
      color: "#fff"
    },
    backgroundColor: "#f7f7f7",
    borderColor: "#f7f7f7"
  }
};
/**
 * series的默认值
 * 可通过配置构造函数的config参数重置
 */
const markPoint = {
  itemStyle: {
    normal: {
      label: {
        show: true,
        position: "inside",
        formatter: param => param.value
      }
    },
    emphasis: {
      label: {
        formatter: param => param.name
      }
    }
  },
  symbolOffset: [0, -20]
};
const defaultSeriesOptions = {
  line: {
    smooth: true,
    symbol: "circle",
    symbolSize: 6,
    lineStyle: {
      opacity: 0.4,
      width: 2
    },
    itemStyle: {
      borderColor: "#fff",
      borderWidth: 1,
      label: {
        show: true,
        position: "top"
      }
    },
    markPoint
  },
  bar: {
    barMaxWidth: 40,
    showBackground: false,
    label: {
      show: false
    },
    itemStyle: {
      normal: {
        barBorderRadius: [4, 4, 0, 0]
      }
    }
  },
  pie: {
    radius: ["30%", "50%"],
    avoidLabelOverlap: true,
    label: {
      show: false,
      position: "center"
    },
    itemStyle: {
      normal: {
        labelLine: {
          show: true
        }
      }
    },
    emphasis: {
      label: {
        show: true,
        fontSize: "12",
        fontWeight: "bold"
      }
    }
  },
  scatter: {
    label: {
      normal: {
        color: "#000",
        show: true,
        formatter: params => {
          return params.value[4];
        }
      }
    },
    symbolSize: value => {
      return (value[2] * 30) / value[3];
    }
  }
};
/**
 * 其他用于计算或展示的默认值
 * fields: [
      { name: '利润', type: 'percent' },
      { name: '同比', type: 'percent' }
    ]
 * field: { type: 'percent' }
 */
const defaultConfig = {
  numPerPage: undefined,
  tooltipSort: "1", // 1正序 -1倒叙
  fields: [],
  field: {}
};

function titleUpperCase(str) {
  if (str) return str[0].toUpperCase() + str.substr(1);
  else return str;
}
/**
 * 提示信息格式化
 * 针对散点图，地图等多个系列
 * 特殊处理可在本类外重写该方法
 * @params Object 返回参数
 * @params config 自定义参数
 * fields: [
    { name: '', type: 'percent' }
  ]
 */
function tooltipFormatter(params, config, tooltip) {
  let html = "";
  let title = "";
  // 把数据倒序，达到最终展示的tooltips和柱子层级顺序一样
  if (config.tooltipSort === "-1" && params.length) params = params.reverse();
  params.map((item, key) => {
    if (!title) title = item.name + "<br>";
    // 为了总激励结构对比、年度激励对比中英翻译添加的逻辑
    // 后端无法直接翻译，只能返回字段再由前端拼接
    if (config.field && config.field.extTitleData) {
      const foundObj = _.find(config.field.extTitleData, ["value", item.name]);
      const prefix = foundObj.date;
      const name = foundObj.name || "";
      const modelName = foundObj.modelName || "";
      const arr = [prefix];
      if (modelName) {
        arr.push(modelName);
      }
      if (name) {
        arr.push(name);
      }
      title = arr.join("-") + "<br>";
    }
    let val = "";
    if (
      (item.value === undefined || isNaN(item.value)) &&
      !Array.isArray(item.value)
    )
      val = "-";
    else {
      let aVal = item.value;
      if (Array.isArray(item.value)) {
        aVal = isNaN(item.value[0]) ? item.value[1] : item.value[0];
      }
      // if (config.tooltipZerofilter && Number(item.value) === 0) return
      const field =
        config.fields.find(field => {
          return item.seriesName === field.name;
        }) ||
        config.field ||
        {};
      val = `<em>`;
      switch (field.type) {
        case "normal":
          val += toThousand(aVal) + (field.unit || "") + `</em>`;
          break;
        case "percent":
          val += toPercent(aVal, 1) + `</em>`;
          break;
        case "decimal":
          val += Number(aVal).toFixed(1) + (field.unit || "") + `</em>`;
          break;
        // 这个类型是用来显示 单车价格策略分析-价格策略表现
        case "origin":
          if (key === 0) {
            // 车辆数量
            val += toThousand(aVal) + `</em>`;
          } else {
            // 价格
            val += aVal + `</em>`;
          }
          break;
        default:
          val += toThousand(aVal) + `</em>`;
          break;
      }
    }
    html =
      html +
      `${item.marker}${substr(item.seriesName, substrLength)}：${val}` +
      "<br>";
  });
  return title + html;
}

/**
 * 提示信息格式化
 * 针对散点图，地图等单个系列
 * @params Object 返回参数
 * @params config 自定义参数
 * fields: [
      { title: '车型', type: '', key: 4 },
      { name: '利润', type: 'percent', key: 0 },
      { name: '同比', type: 'percent', key: 1 },
      { name: '销量', type: 'normal', key: 2, unit: '' }
    ]
 */
function tooltipFormatterItem(params, config, tooltip) {
  let html = "";
  let title = "";
  var value = params.value;
  if (params.seriesType === "scatter") {
    const fields = config.fields;
    fields.length &&
      fields.forEach(item => {
        if (item.title && !title)
          title = `${params.marker}${value[item.key]}<br>`;
        if (item.name) {
          let val = "";
          const field = item;
          val = `<em style="color:${tooltip.hightLightColor};">`;
          switch (field.type) {
            case "normal":
              val += toThousand(value[item.key]) + `</em>` + field.unit;
              break;
            case "percent":
              val += toPercent(value[item.key], 1) + `</em>`;
              break;
            case "decimal":
              val += Number(value[item.key]).toFixed(1) + `</em>` + field.unit;
              break;
            default:
              val += toPercent(value[item.key], 1) + `</em>`;
              break;
          }
          html = html + `${item.name}：${val}` + "<br>";
        }
      });
  } else if (params.seriesType === "pie") {
    // const itemData = params.data || {}
    title = params.seriesName + "<br>";
    let val = `<em style="color:${tooltip.hightLightColor};">`;
    // 默认显示
    val += `${toPercent(params.value, 1)}</em>`;

    html = `${params.marker}${params.name}：${val}`;
  }
  return title + html;
}
/**
 * 提示信息格式化
 * @params Object 返回参数
 * @params config 自定义参数
 * fields: [
    { name: '', type: 'percent' }
  ]
 */
/**
function labelFormatter(param, config) {
  let val = param.value;
  const value = param.value;
  // const itemData = param.data
  const field =
    config.fields.find(field => {
      return param.seriesName === field.name;
    }) ||
    config.field ||
    {};
  if (param.seriesType === "pie") {
    // 默认显示
    val = `${param.name}${toPercent(param.value, 1)})`;
    // 修改显示
  } else {
    if (Object.keys(field).length) {
      switch (field.type) {
        case "normal":
          val = toThousand(value);
          break;
        case "percent":
          val = toPercent(value, 1);
          break;
        case "decimal":
          val = Number(value).toFixed(1);
          break;
        case "origin":
          val = value;
          break;
        default:
          val = toThousand(value);
          break;
      }
    } else {
      val = toThousand(value);
    }
  }
  return val;
}
 */

export class Chart {
  constructor(type, option, config = {}) {
    // config默认值
    this.config = { type: type, ...defaultConfig };
    // option初始值
    this.option = copyObject(option);
    // 合并参数config和option初始值
    const { xAxis, yAxis } = this.option;
    this.option.xAxis = Array.isArray(xAxis) ? xAxis : [xAxis];
    this.option.yAxis = Array.isArray(yAxis) ? yAxis : [yAxis];
    for (const key in config) {
      if (defaultOptions[key]) {
        if (["xAxis", "yAxis"].includes(key) && !Array.isArray(config[key])) {
          config[key] = [config[key]];
        }
        this.option[key] = mergeObject(this.option[key], config[key]);
      } else {
        this.config[key] = config[key];
      }
    }

    // 合并option默认值和初始值
    this.option = mergeObject(defaultOptions, this.option);
    // 特殊处理各种类型
    const method = `set${titleUpperCase(type)}Option`;
    method in this &&
      this[method](defaultOption => {
        const config = this.config;
        this.option = mergeObject(this.option, defaultOption);
        for (const key in config) {
          if (defaultOption[key]) {
            this.option[key] = mergeObject(this.option[key], config[key]);
          }
        }
      });
    return this;
  }
  setPieOption(fn = () => {}) {
    const defaultOptions = {
      tooltip: {
        trigger: "item"
      },
      xAxis: [
        {
          axisLine: {
            show: false
          }
        }
      ]
    };
    fn(defaultOptions);
  }
  setScatterOption(fn = () => {}) {
    const maxValue = this.option.maxValue;
    const defaultOptions = {
      tooltip: {
        trigger: "item"
      },
      grid: {
        top: 120,
        left: 60,
        right: 60,
        bottom: 70
      },
      xAxis: [
        {
          axisLabel: {
            showMinLabel: false,
            showMaxLabel: false
          },
          max: params => {
            const absMaxValue =
              Math.max(Math.abs(params.min), Math.abs(params.max)) || 1;
            return params.max !== -Infinity ? absMaxValue * 1.5 : 1;
          },
          min: params => {
            const absMaxValue =
              Math.max(Math.abs(params.min), Math.abs(params.max)) || 1;
            return params.min !== Infinity ? absMaxValue * 1.5 * -1 : -1;
          }
        }
      ],
      yAxis: [
        {
          axisLine: {
            show: true
          },
          axisLabel: {
            showMinLabel: false,
            showMaxLabel: false
          },
          max: params => {
            const absMaxValue =
              Math.max(Math.abs(params.min), Math.abs(params.max)) || 1;
            return params.max !== -Infinity ? absMaxValue * 1.5 : 1;
          },
          min: params => {
            const absMaxValue =
              Math.max(Math.abs(params.min), Math.abs(params.max)) || 1;
            return params.min !== Infinity ? absMaxValue * 1.5 * -1 : -1;
          }
        }
      ],
      visualMap: {
        min: 0,
        max: maxValue,
        orient: "horizontal",
        right: "20",
        top: "20",
        dimension: 2,
        itemWidth: 20,
        itemHeight: 200,
        calculable: true,
        precision: 0.1,
        text: ["大", "小"],
        textGap: 30,
        backgroundColor: "#fbfbfb",
        padding: [15, 20, 15, 20],
        borderWidth: 1,
        borderColor: "#ddd",
        inRange: {
          symbolSize: [40, 80]
        },
        outOfRange: {
          symbolSize: [10, 70],
          color: ["transparent"]
        },
        target: {
          outOfRange: {
            color: ["transparent"],
            symbolSize: [0, 0]
          }
        },
        controller: {
          inRange: {
            color: ["#CBDDFC", "#3972D5"]
          },
          outOfRange: {
            color: ["#eee"]
          }
        }
      }
    };
    fn(defaultOptions);
  }

  color(color, config) {
    const type = config.type;
    color = color.length ? color : colorObj[type] || colorObj.bar;
    return color;
  }
  tooltip(tooltip = {}, config) {
    if (typeof tooltip.formatter !== "function") {
      if (tooltip.trigger === "item") {
        tooltip.formatter = params =>
          tooltipFormatterItem(params, config, tooltip);
      } else {
        tooltip.formatter = params => tooltipFormatter(params, config, tooltip);
      }
    }
    return tooltip;
  }
  legend(legend = {}, config) {
    // 当 legend 的数据为空时，不需要添加名称
    if (config.type === "pie" && legend.data && legend.data.length === 0) {
      return legend;
    }
    if (!legend.data || legend.data.length <= 0) {
      legend.data = this.option.series.map(item => {
        return substr(item.name, substrLength);
      });
    }
    return Object.assign({}, legend, {
      data:
        legend &&
        legend.data &&
        legend.data.map(name => {
          return {
            name: substr(name, substrLength)
          };
        })
    });
  }
  xAxis(xAxisArr) {
    return xAxisArr.map(xAxis => {
      // if (xAxis.splitLine.show === undefined) {
      //   xAxis.splitLine.show = xAxis && xAxis.type === "value";
      // }
      if (xAxis.axisLabel !== false) {
        xAxis.axisLabel = mergeObject(
          xAxis.axisLabel,
          xAxis.axisLabel.formatter
            ? {}
            : {
                formatter: val => {
                  return xAxis.name && xAxis.name.indexOf("%") > -1
                    ? toPercent(val, 1)
                    : !xAxis.splitLine.show
                    ? val
                    : toThousand(val);
                }
              }
        );
        return xAxis;
      }
    });
  }
  yAxis(yAxisArr) {
    return yAxisArr.map(yAxis => {
      // if (yAxis.splitLine && yAxis.splitLine.show === undefined) {
      //   yAxis.splitLine.show = yAxis && yAxis.type === "value";
      // }
      yAxis.axisLabel = yAxis.axisLabel || {};
      yAxis.axisLabel = mergeObject(
        yAxis.axisLabel,
        yAxis.axisLabel.formatter
          ? {}
          : {
              formatter: val => {
                return yAxis.name.indexOf("%") > -1
                  ? toPercent(val, 1)
                  : !yAxis.splitLine.show
                  ? val
                  : toThousand(val);
              }
            }
      );
      return yAxis;
    });
  }
  dataZoom(dataZoom = {}, config) {
    const option = this.option;
    let start = 0;
    let len = 0;

    const serieLength = Object.keys(
      option.series.reduce((map, item, index) => {
        const key = item.stack || item.name + "_" + index;
        map[key] = map[key] ? map[key] + 1 : 1;
        return map;
      }, {})
    ).length;

    if (option.xAxis[0].data) {
      len = option.xAxis[0].data.length * serieLength;
      start =
        !config.numPerPage || len <= config.numPerPage
          ? 0
          : parseInt(((len - config.numPerPage + 1) / len) * 100);
    }
    if (option.yAxis[0].data && option.yAxis[0].type !== "value") {
      len = option.yAxis[0].data.length * serieLength;
      start =
        !config.numPerPage || len <= config.numPerPage
          ? 0
          : parseInt(((len - config.numPerPage + 1) / len) * 100);
    }
    start = Number(start);
    if (dataZoom.start !== undefined) {
      dataZoom.end = Math.min(100 - start + Number(dataZoom.start), 100);
    } else {
      dataZoom.start = Math.min(start, 100);
      dataZoom.end = 100;
    }
    if (dataZoom.start === 0 && dataZoom.end === 100) {
      dataZoom.show = false;
    }
    dataZoom.orient =
      _.get(this.option.yAxis, "[0].type") === "category" ||
      dataZoom.orient === "vertical"
        ? "vertical"
        : "horizontal";
    return [dataZoom];
  }
  series(series = [], config) {
    if (!series || series.length <= 0) {
      return [];
    }
    return this.option.series.map(item => {
      // const color = this.option.color
      const defaultOptions = defaultSeriesOptions[item.type];
      // 合并defaultOptions的属性
      item.name = substr(item.name, substrLength);

      item = mergeObject(defaultOptions, item);

      // 合并defaultOptions的属性
      item.name = substr(item.name, substrLength);
      // 合并config的属性
      if (defaultOptions) {
        for (const key in config) {
          if (key in defaultOptions) {
            item[key] = mergeObject(item[key], config[key]);
          }
        }
      }
      return item;
    });
  }

  getChart() {
    this.option = {
      ...this.option,
      color: this.color(this.option.color, this.config),
      legend: this.legend(this.option.legend, this.config),
      tooltip: this.tooltip(this.option.tooltip, this.config),
      xAxis: this.xAxis(this.option.xAxis, this.config),
      yAxis: this.yAxis(this.option.yAxis, this.config),
      series: this.series(this.option.series, this.config),
      dataZoom: this.dataZoom(this.option.dataZoom, this.config)
    };
    return this.option;
  }
  // 兼容旧版，不能删除
  getLineChart() {
    return this.getChart();
  }
  getBarChart() {
    return this.getChart();
  }
  getPieChart() {
    return this.getChart();
  }
  getScatterChart() {
    return this.getChart();
  }
}
